import { createFileRoute } from '@tanstack/react-router'
import AgentesPage from '@/pages/dashboard/agentes-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes/',
)({
  component: function AgentesRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <AgentesPage />
      </ProtectedRoute>
    )
  },
})
